// src/components/common/Loading.js
import React from 'react';

export default function Loading({ message = 'Loading...' }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-muted">
      <div className="text-center space-y-4">
        <div className="spinner"></div>
        <p className="text-mutedink font-medium">{message}</p>
      </div>
    </div>
  );
}